/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const HeadacheIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M35.7 7.6c1.1-1.3 1.5-2.4 1.3-3.3-.6-2.6-5.7-2.6-6.4-2.6-3-.2-5.9.3-8.6 1.2-.3.1-.4.4-.3.6.1.3.4.4.6.3 2.7-.8 5.4-1.3 8.2-1.2 1.3 0 5 .3 5.4 1.9.1.5 0 1.4-1.3 2.7-2.6-1.1-5.4-1.6-8.4-1.6-10 0-18.5 6.7-21.3 15.8-.7-.1-1.2-.3-1.5-.5-1.1-.7-1.2-1.7-1.2-2.2.4-4.7 7.6-8.7 7.7-8.8.2-.1.3-.4.2-.7-.1-.2-.4-.3-.7-.2-.3.2-7.8 4.4-8 9.5 0 1.3.6 2.4 1.7 3.1.5.3 1.1.5 1.7.6-.4 1.8-.7 3.6-.7 5.5C4.1 40 14.1 50 26.3 50c12.3 0 22.2-10 22.2-22.2.1-9-5.2-16.7-12.8-20.2zm-9.4-.5c2.5 0 4.9.5 7.1 1.3-2 1.8-5.5 4.2-11.6 7.4-7.7 4.2-12.4 5.5-15.1 5.6C9.4 13.1 17.1 7.1 26.3 7.1zm0 41.3c-11.4 0-20.7-9.3-20.7-20.7 0-1.9.3-3.7.7-5.4 3.6-.1 9-2 16-5.7 5.7-3.1 9.8-5.7 12.1-7.9C41.9 12 47 19.3 47 27.8c0 11.4-9.2 20.6-20.7 20.6z' />
			<path d='M15.3 21.6c-.3-.3-.8-.2-1.1.2-.3.3-.2.8.2 1.1l3.7 2.7-4.1 1.7c-.4.1-.5.5-.5.9.1.4.5.7.9.6h.1l6.7-2.8-5.9-4.4zM39.1 27.4 35 25.5l3.6-2.6c.3-.3.4-.7.2-1.1-.3-.3-.7-.4-1.1-.2L32 25.8l6.5 3s.1 0 .1.1c.4.1.7-.1.9-.4.2-.5 0-1-.4-1.1zM31.2 33.4l-4.1 4.2-4.3-4.1-4.6 5.4c-.1.1-.2.3-.2.5 0 .4.3.8.8.8.2 0 .4-.1.6-.3l3.5-4.1 4.2 4 4-4.1 3.6 4.1c.3.3.8.4 1.1.1.3-.3.4-.8.1-1.1l-4.7-5.4zM7.2 4.2c.5.2 1 .3 1.5.5.4.1.6.3.6.8-.1.4 0 .9-.1 1.3l-.1.1c.1.2.2.5.4.7.4.2.6-.1.8-.3.3-.3.6-.7.9-1 .2-.4.7-.5 1.1-.3.6 0 1.2.2 1.7.3.2.1.5 0 .7-.1.1-.2.1-.4 0-.6l-.9-1.2-.1-.1c-.2-.3-.1-.7.2-.9.4-.4.7-.7 1-1.2.1-.2.2-.4.1-.6-.2-.2-.4-.2-.7-.2-.5.1-1.1.2-1.6.4-.4.2-.9 0-1.2-.4-.2-.4-.5-.8-.8-1.1-.2-.2-.5-.3-.7-.3-.2.1-.4.3-.4.6-.1.5-.1 1-.1 1.5 0 .4-.2.6-.6.7-.6.1-1.2.2-1.7.4-.2.1-.4.3-.6.5.2.2.3.4.6.5zM16.8 2.8c.3.3.4.5 0 .9-.2.2-.3.4-.5.6-.1.1-.1.3-.1.4.2 0 .4.1.6 0 .3-.1.5-.1.8-.2.3-.2.7-.1.9.2l.6.6c.1.1.3.1.4.1.1 0 .2-.2.2-.3v-.3c-.1-1.1-.1-.9.9-1.2.4-.3.6-.4.9-.6-.3-.2-.5-.3-.8-.4-.9-.2-.9-.2-1-1v-.5c0-.1-.1-.2-.3-.3-.1 0-.3 0-.4.1 0 .1-.1.1-.1.2-.5.8-1.5 1.1-2.3.6-.1 0-.3 0-.4.1-.1.1 0 .3 0 .4l.6.6z' />
		</svg>
	)
}

export default HeadacheIcon
